// extracted by mini-css-extract-plugin
export default {"cls1":"SnackBar-cls1___a05392b0518ffbd6fc8","cls2":"SnackBar-cls2___76262fdff275f6d30cd SnackBar-cls1___a05392b0518ffbd6fc8"};